export default {
  init() {
    // JavaScript to be fired on the about us page
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      // Hide all images first
      $('.industry-image').removeClass('d-block').addClass('d-none');
      // Show image for current tab
      $(`.industry-image.${e.target.dataset.imageClass}`).removeClass('d-none').addClass('d-block');
      console.log(e);
    })
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/industries.js